import styled from "styled-components";

const DashboardStyle = styled.div`
  .dashboard-row {
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .overview-details-container1,
  .overview-details-container2 {
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0px 4px 30px 0px #0000001f;
    display: flex;
    flex-direction: column;
  }
  .overview-details-container1 {
    min-height: 325px;
  }
  .overview-details-container2 {
    min-height: 378px;
  }
  .overview-details-box {
    height: -webkit-fill-available;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    gap: 10px;
    padding: 1.5rem 0.5rem;
    border-radius: 5px;
    color: rgb(0, 0, 0);

    .overview-details {
      flex: 1 1 calc(50% - 10px);
      min-width: 140px;
      box-sizing: border-box;
      min-height: 96px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 10px;
      background: rgb(245, 245, 246);
      border-radius: 8px;
    }
    .quick-actions-details {
      width: 48%;
      padding: 10px;
      background: rgb(245, 245, 246);
      cursor: pointer;
      border-radius: 8px;
    }
  }
  .quick-actions-details:hover {
    background-color: rgb(32, 125, 215);
    color: rgb(255, 255, 255);
  }
  .details-box-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0px;
    word-break: break-word;
    hyphens: auto;
    text-align: left;
    color: rgba(31, 36, 59, 1);
  }

  .overview-value {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0px;
    color: rgba(31, 36, 59, 1);
  }

  .overview-label {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.3;
    margin: 0px;
    color: rgba(31, 36, 59, 1);
  }
  .quick-actions-img {
    width: 30px;
    font-size: 30px;
    padding-bottom: 12px;
  }

  .events_data_box_container {
    text-align: justify;
    height: 320px;
    overflow: hidden scroll;
  }
  .events_data_box {
    padding: 2px 6px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    &:hover {
      background: rgba(116, 176, 234, 0.25);
    }
  }

  .creation-date {
    color: rgb(92, 100, 104);
    font-size: 12px;
    margin-bottom: 4px;
  }
  .dashboard_lazy_loading_container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-around;
  }
  // .dashboard_lazy_loading_box{
  //     width: 50%;
  // }

  .event_name {
    width: 70%;
    font-size: 0.889rem;
    font-weight: 400;
    margin-top: 6px;
  }

  .event-indicate-icon {
    height: 12px;
    width: 12px;
    border-radius: 50px;
    background: rgb(27, 104, 179);
  }
  .event-backward-img {
    rotate: 90deg;
    font-size: 20px;
    color: rgb(27, 104, 179);
  }
  .timeline-details {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dashboard_lazy_loading {
    width: 35vw;
    height: 300px;
  }
  @media (min-width: 320px) and (max-width: 992px) {
    .dashboard_lazy_loading_container {
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: space-around;
    }
    .dashboard_lazy_loading {
      width: 100%;
      height: 300px;
    }
  }
  .recent-activity-style {
    text-align: left;
    overflow: hidden auto;
    height: 220px;
  }
  .activity-label {
    font-size: 14px;
    font-weight: 400;
    color: #1f243b;
    margin-left: 10px;
  }
  .activity-value {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
    margin-left: 10px;
  }
  .activity-details {
    transition: background-color 0.3s ease;
  }
  .activity-details:hover {
    background-color: #f4f4f4;
  }
  // These footer buttons are plain <button> elements, not antd's Button -
  // antd's own "+ .ant-btn { margin-left }" spacing rule only applies
  // between actual Button components, so it never kicked in here and the
  // Cancel/Save and No/Yes pairs sat flush against each other.
  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .to-do-button {
    background-color: #c2fae5;
    border: none;
    height: 34px;
    padding: 0 20px;
    border-radius: 8px;
    font-family: DM Sans;
    font-size: 16px;
    font-weight: 400;
    color: #1f243b;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #a9f2d8;
    }
  }
  .to-do-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .to-do-style {
    flex: 1;
    min-height: 0;
    max-height: 260px;
    overflow: hidden auto; 
    margin-top: 30px;
  }
  // Checkbox {
  //     width: 24px;
  //     height: 24px;
  //     border-radius: 6px;
  //     border: 1.5px;
  // }
  .custom-checkbox .ant-checkbox .ant-checkbox-inner {
    width: 24px !important;
    height: 24px !important;
  }
  .custom-checkbox input[type="checkbox"]:checked {
    accent-color: #08c108;
    border-color: #08c108;
    width: 24px;
    height: 24px;
  }
  .custom-checkbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #08c108 !important;
    border-color: #08c108;
    width: 24px;
    height: 24px;
  }
  .learner-progress-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
  }
  .select-dropdown-style {
    width: 230px;
    max-width: 100%;
    flex-shrink: 0;
  }
  .select-dropdown-style .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    align-items: center;
  }
  .select-dropdown-style .ant-select-item-option {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #1f243b;
  }
  .select-dropdown-style .ant-select-selection-placeholder {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #1f243b;
  }
  .todo-checkbox-text {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #1f243b;
    margin-left: 10px;
  }
  .todo-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 12px;
    border-radius: 8px;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f1f1f1;
    }

    > div:first-child {
      flex: 1;
      min-width: 0;
    }
  }

  /* Due date and the edit/delete actions share one grid cell, so the row
     never changes size: the due date shows normally and, while the row is
     hovered, swaps for the actions. */
  .todo-right {
    flex-shrink: 0;
    display: grid;
    align-items: center;
    justify-items: end;
  }

  .todo-right > * {
    grid-area: 1 / 1;
  }

  /* The due date sits in the same cell as the actions - it must never catch
     the click meant for the (hover-revealed) edit/delete buttons. */
  .todo-due {
    text-align: right;
    pointer-events: none;
    transition: opacity 0.15s ease;
  }

  .todo-due-date {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    color: #636980;
  }

  .todo-due-overdue .todo-due-date {
    color: #e53935;
  }

  .todo-actions {
    display: flex;
    align-items: center;
    gap: 34px;
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  .todo-content:hover .todo-due,
  .todo-right:focus-within .todo-due {
    opacity: 0;
  }

  .todo-content:hover .todo-actions,
  .todo-actions:focus-within {
    opacity: 1;
  }

  /* Mint badge behind the plain pencil / trash icon, as in the design. */
  .todo-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 4px;
    background: #c2fae5;
    color: #1f243b;
    cursor: pointer;
    flex-shrink: 0;
  }

  .todo-action-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  /* No hover on touch screens - keep the due date and the actions both
     visible so edit/delete stay reachable. */
  @media (hover: none) {
    .todo-right {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .todo-due,
    .todo-content:hover .todo-due {
      opacity: 1;
    }

    .todo-actions {
      opacity: 1;
      gap: 8px;
    }
  }

  .pie_chart_container {
    width: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 12px;
    place-items: center;
  }

  .pie_chart_wrapper {
    width: 100%;
  }

  .chart_legents_wrapper {
    width: 75%;
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: space-between;
  }

  .chart_legents_label {
    display: flex;
    gap: 12px;
  }

  .legents_label_color_wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .legents_label {
    margin: 0px !important;
  }
  .legents_value {
    margin: 0px !important;
  }

  .chart_legents_label_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  /* Create / Edit To-dos modals */
  .todo-modal .ant-modal-title {
    font-size: 16px;
    font-weight: 700;
    color: #1f243b;
  }
  .todo-modal .ant-modal-header {
    margin-bottom: 20px;
  }
  .todo-modal .ant-modal-footer {
    margin-top: 28px;
  }
  .todo-modal-button {
    min-width: 130px;
  }
  .todo-modal-button-outline,
  .todo-modal-button-outline:hover {
    background-color: #ffffff;
    border: 1px solid #1f243b;
  }
  .create-todo-checklist {
    border: 1px solid #e2e4e9;
    border-radius: 8px;
    padding: 12px 14px;
    height: 194px;
    overflow-y: auto;
  }
  .create-todo-checklist-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 0;
  }
  .todo-modal-checkbox .ant-checkbox-inner {
    width: 16px;
    height: 16px;
  }
  .todo-modal-checkbox.ant-checkbox-wrapper-disabled .ant-checkbox-inner {
    background-color: #ffffff;
    border-color: #d9d9d9;
  }
  .todo-modal-checkbox .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #08c108;
    border-color: #08c108;
  }
  .todo-modal-text {
    font-size: 14px;
    color: #1f243b;
    padding-left: 2px;
  }
  .create-todo-inline-input {
    flex: 1;
    padding: 0;
    font-size: 14px;
    color: #1f243b;
  }
  .create-todo-date-label {
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #636980;
    margin: 20px 0 8px;
  }
  .create-todo-date-picker {
    width: 100%;
    height: 40px;
    border-radius: 5px;
  }

  /* Delete confirmation */
  .todo-delete-modal .ant-modal-content {
    padding: 24px 24px 20px;
  }
  .todo-delete-modal .ant-modal-footer {
    justify-content: center;
    margin-top: 24px;
  }
  .todo-delete-text {
    margin: 0;
    font-size: 14px;
    color: #1f243b;
    text-align: center;
  }

  /* "Deleted" success pop-up */
  .todo-deleted-modal .ant-modal-content {
    padding: 20px 16px 16px;
  }
  .todo-deleted-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    p {
      margin: 0;
      font-size: 14px;
      color: #1f243b;
    }
  }
  .todo-deleted-icon {
    position: relative;
    display: inline-flex;
    color: #1f243b;

    svg {
      width: 30px;
      height: 30px;
    }
  }
  .todo-deleted-check {
    position: absolute;
    right: -4px;
    bottom: 2px;
    font-size: 12px;
    color: #08c108;
    background: #ffffff;
    border-radius: 50%;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export default DashboardStyle;
